const getBaseName = (assetPathOrURL /*:: :string */) =>
	assetPathOrURL.split('#')[0].split('?')[0].split('/').pop();

/**
 * Given an asset path or URL isolate the basename and remove the chunk hash and cache-bust integer.
 *
 * IMPORTANT
 *  - this algorithm must exactly match the webpack output filename format in webpack.config.js
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */
const sanitiseAssetName = (isDevelopment /*:: :boolean */) /*:: :(string => string) */ =>
	(assetPathOrURL /*:: :string */) => {
		const baseName = getBaseName(assetPathOrURL);

		// we desire "[name.with.dots].[ext]"
		// in debug we expect "[name.with.dots].[ext]"
		// in production we expect "[name.with.dots].[hash].[cache-bust].[ext]"
		const split = baseName.split('.');

		if (process.env.BUNDLER === 'parcel') {
			if (split.length === 1) {
				// Inline bundles are only an id
				return split[0];
			}
			// Remove the has section from bundles (penultimate section separated by dots)
			// In the case of shared bundles (e.g. shared.hash.js) this will return 'shared.js'.
			// In the case of runtime bundles (e.g. bundle.runtime.hash.js) this will return 'bundle.runtime.js'.
			// This will cause only the first shared bundle loaded to be tracked.
			// In the short term this is desired to prevent too much noise.
			return [...split.slice(0, -2), split[split.length - 1]].join('.');
		}

		return isDevelopment || split.length < 4
			? baseName
			: [...split.slice(0, -3), ...split.slice(-1)].join('.');
	};

module.exports = {
	sanitiseAssetName,
};
